import { Routes } from '@angular/router';

import { FACULTIES_POPUPS_ROUTES, FACULTIES_ROUTES } from './faculties/faculties.route';
import { QUEUES_POPUPS_ROUTES, QUEUES_ROUTES } from './queues/queues.route';
import { USERS_POPUPS_ROUTES, USERS_ROUTES } from './users/users.route';
import { ManagementComponent } from './management.component';

export const MANAGEMENT_ROUTES: Routes = [
    {
        path: 'management',
        component: ManagementComponent,
        children: [
            {
                // Default path for /management route
                path: '',
                redirectTo: 'faculties',
                pathMatch: 'full'
            },
            ...FACULTIES_ROUTES,
            ...QUEUES_ROUTES,
            ...USERS_ROUTES
        ]
    },
    ...QUEUES_POPUPS_ROUTES,
    ...FACULTIES_POPUPS_ROUTES,
    ...USERS_POPUPS_ROUTES
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/management.route.ts